// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-new-tag[data-v-c5f403e4]{width:90px;margin-left:10px;vertical-align:bottom}.footer[data-v-c5f403e4]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.el-message-box[data-v-c5f403e4]{width:900px}.noForm[data-v-c5f403e4]{text-align:left}[role=dialog] .el-col-24[data-v-c5f403e4]:last-of-type{padding-top:0 !important}.ml75[data-v-c5f403e4]{margin-left:75px}[data-v-c5f403e4] [role=dialog] .el-message-box{padding-bottom:10px !important}", ""]);
// Exports
module.exports = exports;
